import { hopsFor, isLiveVisit } from './travel.js'
import type { BoardVisit } from './types.js'

/** Visit predicates behind the board's filters and the late count. */

export function isRunningLate(visit: BoardVisit, now = new Date()): boolean {
  if (!isLiveVisit(visit)) return false
  if (visit.status === 'ON_SITE') return now > visit.endAt
  if (visit.status === 'EN_ROUTE') return now > visit.startAt
  return visit.status === 'CONFIRMED' && now > visit.startAt
}

export function isOutNow(visit: BoardVisit): boolean {
  return visit.status === 'EN_ROUTE' || visit.status === 'ON_SITE'
}

export function isCommercial(visit: { job: { client: { type?: string | null } } }): boolean {
  return visit.job.client.type === 'COMMERCIAL'
}

/** Tight hops across the board, for the day-summary "minutes recoverable". */
export function tightMinutes(visitsByPerson: Map<string, BoardVisit[]>): number {
  let total = 0
  for (const visits of visitsByPerson.values()) {
    for (const hop of hopsFor(visits)) {
      if (hop.tight) total += hop.minutes
    }
  }
  return total
}
